// projectData.js

export const projectCategories = [
  {
    category: 'Apps',
    projects: [
      { name: 'Mantica', url: 'https://mantica.app/' },
      { name: 'Squada', url: 'https://squada.io/' },
      { name: 'AIIA+', url: 'https://aiia.plus/' },
      { name: 'JATR', url: 'https://jackandtheripper.tv/' },
      // { name: 'AI Dream Interpreter', url: 'https://ai-dream-interpreter.com/' },
      // { name: 'CinemAI', url: 'https://www.cinem-ai.app/' },
    ],
  },
  {
    category: 'Games',
    projects: [
      { name: 'Prompt Battles', url: 'https://promptbattles.art/' },
      { name: 'JATR-GameRoom', url: 'https://www.jackandtheripper.tv/games' },
      // { name: 'JATR-2D', url: 'https://www.jackandtheripper.tv/jatr2d' },
      // { name: 'Squada-Wallet', url: 'https://chromewebstore.google.com/detail/squada-wallet/phngkgphibplhbdhlkpcbldpacehbkee?hl=es' },
      // { name: 'NFT Keycard', url: 'https://opensea.io/assets/matic/0x2953399124f0cbb46d2cbacd8a89cf0599974963/44112812388747551703647041218726354135081957575981677950372403531492194516993' },
      
      // Add more Web3 projects
    ],
  },
  {
    category: 'Assets',
    projects: [
      { name: 'Game Ready Assets', url: 'https://www.artstation.com/squada' },
      { name: 'VFX Video Animations', url: 'https://www.youtube.com/channel/UCaKvPVChnOVFqmtqIp-LZUA' },
      // { name: 'Assets Project 2', url: 'https://assets-project2.com/' },
      // Add more Assets projects https://www.squada.io/assets
    ],
  },
  {
    category: 'Events',
    projects: [
      { name: 'Talent Land', url: 'https://www.talent-land.mx/prompt-battles/' }, //{ name: 'La Tercera Ola Digital', url: 'https://www.centroculturadigital.mx/actividad/la-tercera-ola-digital' },
      { name: 'Prompt Battles', url: 'https://promptbattles.art/' }, //https://www.centroculturadigital.mx/actividad/prompt-battles     https://www.talent-land.mx/prompt-battles/
    ],
  },
  // {
  //   category: 'Shop',
  //   projects: [
  //     { name: 'Merchandise', url: 'https://www.squada.io/shop' },
  //     { name: 'Prints', url: 'https://www.squada.io/shop' }, 
  //   ],
  // },
  // {
  //   category: 'Supporters',
  //   projects: [
  //     { name: 'Patreon', url: 'https://www.patreon.com/SQUADA' },
  //     { name: 'Producer Credits', url: 'https://www.squada.io/producer-credits' },
      
  //   ],
  // },
  // {
  //   category: 'Contact',
  //   projects: [
  //     { name: 'Desktop', url: '' },
  //     { name: 'Mobile', url: '' },
      
  //   ],
  // },
  // {
  //   category: 'Home Controls',
  //   projects: [
  //     { name: 'Desktop', url: '' },
  //     { name: 'Mobile', url: '' },
      
  //   ],
  // },
];












// // projectData.js

// export const projectCategories = [
//     {
//       category: 'AI',
//       projects: [
//         { name: 'AI Dream Interpreter', url: 'https://ai-dream-interpreter.com/' },
//         { name: 'AI Therapy', url: 'https://ai-therapy.io/' },
//         { name: 'AI Painter', url: 'https://aipainter.studio/' },
//         // { name: 'Prompt Battles', url: 'https://promptbattles.art/' },
//         { name: 'The AI Sage', url: 'https://the-ai-sage.com/' },
//         // { name: 'CinemAI', url: 'https://www.cinem-ai.app/' },
//       ],
//     },
//     {
//       category: 'Web3',
//       projects: [
//         { name: 'Squada-DEX', url: 'https://www.squada-dex.online/' },
//         { name: 'Squada-Token', url: 'https://etherscan.io/tx/0x956096f5083a9fcfc52304563233d88a6218d21c32ac3a61ff25016fbd1aa34d' },
//         { name: 'Squada-Wallet', url: 'https://chromewebstore.google.com/detail/squada-wallet/phngkgphibplhbdhlkpcbldpacehbkee?hl=es' },
//         { name: 'NFT Keycard', url: 'https://opensea.io/assets/matic/0x2953399124f0cbb46d2cbacd8a89cf0599974963/44112812388747551703647041218726354135081957575981677950372403531492194516993' },
        
//         // Add more Web3 projects
//       ],
//     },
//     {
//       category: 'Assets',
//       projects: [
//         { name: 'Game Ready Assets', url: 'https://www.artstation.com/squada' },
//         { name: 'VFX Video Animations', url: 'https://www.youtube.com/channel/UCaKvPVChnOVFqmtqIp-LZUA' },
//         // { name: 'Assets Project 2', url: 'https://assets-project2.com/' },
//         // Add more Assets projects https://www.squada.io/assets
//       ],
//     },
//     {
//       category: 'Events',
//       projects: [
//         { name: 'Talent Land', url: 'https://www.talent-land.mx/prompt-battles/' }, //{ name: 'La Tercera Ola Digital', url: 'https://www.centroculturadigital.mx/actividad/la-tercera-ola-digital' },
//         { name: 'Prompt Battles', url: 'https://promptbattles.art/' }, //https://www.centroculturadigital.mx/actividad/prompt-battles     https://www.talent-land.mx/prompt-battles/
//       ],
//     },
//     // {
//     //   category: 'Shop',
//     //   projects: [
//     //     { name: 'Merchandise', url: 'https://www.squada.io/shop' },
//     //     { name: 'Prints', url: 'https://www.squada.io/shop' }, 
//     //   ],
//     // },
//     // {
//     //   category: 'Supporters',
//     //   projects: [
//     //     { name: 'Patreon', url: 'https://www.patreon.com/SQUADA' },
//     //     { name: 'Producer Credits', url: 'https://www.squada.io/producer-credits' },
        
//     //   ],
//     // },
//     // {
//     //   category: 'Contact',
//     //   projects: [
//     //     { name: 'Desktop', url: '' },
//     //     { name: 'Mobile', url: '' },
        
//     //   ],
//     // },
//     // {
//     //   category: 'Home Controls',
//     //   projects: [
//     //     { name: 'Desktop', url: '' },
//     //     { name: 'Mobile', url: '' },
        
//     //   ],
//     // },
//   ];